import * as z from 'zod';
import {
    BILLING_TYPE,
    CALCULATION_TYPE,
    CAPPING,
    DAY_OF_WEEK,
    FREE_TIME_TYPE, PAYMENT_TYPE,
    PRICING_PLAN_STATUS,
    TICK_TYPE
} from 'src/features/pricingPlan/utils/types';
import { CURRENCY } from 'src/types';

export type PricingPlanFormSchemaValues = z.infer<typeof pricingPlanFormSchema>;
export const pricingPlanFormSchema = z.object({
    translations: z
        .array(
            z.object({
                language: z.string(),
                name: z.string().min(1),
                description: z.string().optional(),
            }),
        )
        .min(1),
    calculation_type: z.enum(CALCULATION_TYPE),
    billing_type: z.enum(BILLING_TYPE),
    status: z.enum(PRICING_PLAN_STATUS),
    valid_from: z.string(),
    valid_to: z.string().optional().nullable(),
    tax_percent: z.string(),
    currency: z.enum(CURRENCY),
    free_time_type: z.enum(FREE_TIME_TYPE),
    free_time_cap_minutes: z.number().nullable(),
    free_time_minutes: z.number().nullable(),
    exit_time: z.number().nullable(),
    exit_time_grace: z.number().nullable(),
    capping: z.enum(CAPPING).optional(),
    tick: z
        .object({
            tick_type: z.enum(TICK_TYPE),
            tick_minutes: z.number(),
        })
        .optional()
        .nullable(),
    fixed_rate: z
        .object({
            rate_with_tax: z.string(),
        })
        .optional()
        .nullable(),
    identity: z.string().optional(),
});

export type PricingPlanCapFormSchemaValues = z.infer<typeof pricingPlanCapFormSchema>;
export const pricingPlanCapFormSchema = z.object({
    cap_type: z.enum(TICK_TYPE),
    cap_minutes: z.number(),
    rate_with_tax: z.number(),
});

const tickRateFormSchema = z.object({
    from_time: z.string(),
    to_time: z.string(),
    rate_with_tax: z.number().min(0),
});

export type PricingPlanTickRateCreateValues = z.infer<typeof pricingPlanTickRateCreate>;
export const pricingPlanTickRateCreate = tickRateFormSchema.extend({
    day_of_week: z.enum(DAY_OF_WEEK),
});

export type PricingPlanTierFormSchemaValues = z.infer<typeof pricingPlanTierFormSchema>;
export const pricingPlanTierFormSchema = z.object({
    start_minute: z.number().min(0),
    end_minute: z.number().nullable().optional(),
    rate_with_tax: z.number(),
    tick_type: z.enum(TICK_TYPE),
    tick_minutes: z.number(),
});

export type PricingPlanPeriodAdjustmentFormSchemaValues = z.infer<typeof pricingPlanPeriodAdjustmentFormSchema>;
export const pricingPlanPeriodAdjustmentFormSchema = z.object({
    payment_type: z.enum(PAYMENT_TYPE),
    valid_from: z.string(),
    valid_to: z.string().nullable().optional(),
    day_of_week: z.enum(DAY_OF_WEEK).nullable().optional(),
    from_time: z.string().nullable().optional(),
    to_time: z.string().nullable().optional(),
    adjustment_percent: z.string().nullable().optional(),
    adjustment_amount: z.number().nullable().optional(),
});

export type PricingPlanTickRateFormSchemaValues = z.infer<typeof pricingPlanTickRateFormSchema>;
export const pricingPlanTickRateFormSchema = tickRateFormSchema.extend({
    day_of_week: z.array(z.enum(DAY_OF_WEEK)).min(1),
});